import { FooterBrand, FooterLinks, FooterVisit, FooterHours } from "./FooterParts";

export default function Footer() {
  return (
    <footer className="bg-[#0a2424] text-white/80 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 lg:px-10 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-14">
          <FooterBrand />
          <FooterLinks />
          <FooterVisit />
          <FooterHours />
        </div>

        <div className="border-t border-white/10 mt-14 pt-7 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/45">
          <p>© {new Date().getFullYear()} Sea Spice Kitchen. All rights reserved.</p>
          <p className="tracking-wide">Fully licensed venue. We practise the Responsible Service of Alcohol.</p>
        </div>
      </div>
    </footer>
  );
}
